export default __webpack_public_path__ + "static/media/tooltip-discapacidad2.16d9b4e5.png";